import { useCallback, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  LegalClientAccountDocumentsQuery,
  useLegalClientAccountDocumentsLazyQuery,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseFileEntity } from 'api/requests/onboarding/helpers';
import { lodash } from 'helpers';

const parseData = (data?: LegalClientAccountDocumentsQuery) =>
  lodash.compact(data?.accountDocuments).map(parseFileEntity);

export const useLegalClientAccountDocumentsLazy = () => {
  const [handle, { loading, error: apolloError, data }] =
    useLegalClientAccountDocumentsLazyQuery();

  const error = useError(apolloError);

  const getAccountDocuments = useCallback(
    async (id: string) => {
      const { data } = await handle({ variables: { id } });
      return parseData(data);
    },
    [handle]
  );

  return {
    documents: useMemo(() => parseData(data), [data]),
    getAccountDocuments,
    loading,
    error,
  };
};
